import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'tidy-round-button-row',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./round-button-row.component.scss'],
  template: `
    <ng-content></ng-content>
  `
})

export  class RoundButtonRowComponent {
}
